"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const app_1 = require("./app");
const storeToken_1 = require("./storeToken");
const addDomain_1 = require("./addDomain");
function signupWithEmail(context) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { email, password, role } = context;
            let { domainId } = context;
            const data = yield app_1.app.auth.createUserWithEmailAndPassword(email, password);
            const { displayName, providerData, refreshToken, uid } = data.user;
            // create domain while signing up as teacher
            if (role === identifiers_1.Types.UserPermissionRoles.TEACHER && !domainId) {
                const domainInfo = yield addDomain_1.default({
                    name: Math.random().toString(36).substring(7)
                });
                domainId = domainInfo.id;
            }
            const tokenData = {
                refreshToken,
                uid,
                name: displayName,
                email,
                domainId: domainId ? domainId : '',
                providerId: providerData[0].providerId,
                role
            };
            return yield storeToken_1.default(tokenData, password);
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = signupWithEmail;
//# sourceMappingURL=signupWithEmail.js.map